var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9995 44.0007H8.15945C5.83945 44.0007 3.93945 42.1407 3.93945 39.8607V10.1807C3.93945 4.9407 7.83945 2.5607 12.6195 4.9007L21.4995 9.2607C23.4195 10.2007 24.9995 12.7007 24.9995 14.8207V44.0007Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.94 30.1198V37.6798C43.94 41.9998 41.94 43.9998 37.62 43.9998H25V20.8398L25.94 21.0398L34.94 23.0598L39 23.9598C41.64 24.5398 43.8 25.8998 43.92 29.7398C43.94 29.8598 43.94 29.9798 43.94 30.1198Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 18H17.94",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 26H17.94",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9395 23.0591V29.4991C34.9395 31.9791 32.9195 33.9991 30.4395 33.9991C27.9595 33.9991 25.9395 31.9791 25.9395 29.4991V21.0391L34.9395 23.0591Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9195 29.7386C43.7995 32.0986 41.8395 33.9986 39.4395 33.9986C36.9595 33.9986 34.9395 31.9786 34.9395 29.4986V23.0586L38.9995 23.9586C41.6395 24.5386 43.7995 25.8986 43.9195 29.7386Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.e91900a89deff5ee2c9aabc96c53f9ba.svg";
export { ForwardRef as ReactComponent };